<script lang="ts">
  import type { OptionModel, SessionLightModel, SessionModel } from '@24hbs/utils';
  import { getDisplayedPrice, getDisplayedPriceForcedIva } from '$lib/utils/price-utils';

  export let option: OptionModel;
  export let session: SessionModel | SessionLightModel;
  export let hasVatFree: boolean;

  export let showOnlyOriginal: boolean = false;
  export let tabletMobile: boolean = false;
  export let mandatory: boolean = false;
  export let label: string = '';
  export let showPriceWithIva: boolean = false;
</script>

<div class="option-price" class:mandatory class:tabletMobile>
  {#if label}
    <span class="label text-center font-semibold">{label}</span>
  {/if}
  {#if showPriceWithIva}
    {#if option.discountPrice > 0 && !showOnlyOriginal}
      <span class="deleted-price">{getDisplayedPriceForcedIva('original', hasVatFree, session, option)}*</span>
      <span class="price">{getDisplayedPriceForcedIva('discount', hasVatFree, session, option)}*</span>
    {:else}
      <span class="price">{getDisplayedPriceForcedIva('original', hasVatFree, session, option)}*</span>
    {/if}
  {:else}
    {#if option.discountPrice > 0 && !showOnlyOriginal}
      <span class="deleted-price">{getDisplayedPrice('original', hasVatFree, session, option)}</span>
      <span class="price">{getDisplayedPrice('discount', hasVatFree, session, option)}</span>
    {:else}
      <span class="price">{getDisplayedPrice('original', hasVatFree, session, option)}</span>
    {/if}
  {/if}
</div>

<style type="text/scss" lang="scss" scoped>
  .option-price {
    @apply text-sm leading-4;
    @apply flex flex-col;

    &.mandatory {
      @apply text-base;
    }

    .deleted-price {
      @apply line-through	text-gray-600;
    }
    .price {
    }
  }

  .tabletMobile.option-price {
    @apply flex flex-row justify-between;
    @apply pb-5;

    .label {
      @apply mr-1;
    }

    &.mandatory {
    }
  }
</style>
